document.querySelectorAll('.custom-personalization').forEach(function (root) {
  var fileInput = root.querySelector('[data-custom-image-input]');
  var preview = root.querySelector('[data-custom-image-preview]');
  var previewLabel = root.querySelector('[data-custom-image-preview-label]');
  var errorWrapper = root.querySelector('[data-custom-image-error]');
  var errorText = root.querySelector('[data-custom-image-error-text]');

  if (!fileInput || !preview || !previewLabel || !errorWrapper || !errorText) return;

  var MAX_FILE_BYTES = 20 * 1024 * 1024; // 20MB
  var MAX_DIMENSION_PX = 8000; // matches the server-side cap in customized-generate-run.ts

  function clearPreview() {
    var existingImg = preview.querySelector('img');
    if (existingImg) existingImg.remove();
    previewLabel.hidden = false;
    preview.setAttribute('data-empty', '');
  }

  function showError(message) {
    errorText.textContent = message;
    errorWrapper.hidden = false;
    fileInput.value = '';
    clearPreview();
  }

  function clearError() {
    errorWrapper.hidden = true;
    errorText.textContent = '';
  }

  preview.addEventListener('click', function () {
    fileInput.click();
  });
  preview.addEventListener('keydown', function (evt) {
    if (evt.key === 'Enter' || evt.key === ' ') {
      evt.preventDefault();
      fileInput.click();
    }
  });

  fileInput.addEventListener('change', function () {
    var file = fileInput.files && fileInput.files[0];
    if (!file) return;

    clearError();

    if (file.size > MAX_FILE_BYTES) {
      showError('That image is too large (max 20MB). Please choose a smaller file.');
      return;
    }

    var objectUrl = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      if (img.naturalWidth > MAX_DIMENSION_PX || img.naturalHeight > MAX_DIMENSION_PX) {
        showError('That image\'s dimensions are too large. Please choose a smaller file.');
        URL.revokeObjectURL(objectUrl);
        return;
      }

      var existingImg = preview.querySelector('img');
      if (existingImg) existingImg.remove();
      previewLabel.hidden = true;
      preview.removeAttribute('data-empty');

      var previewImg = document.createElement('img');
      previewImg.src = objectUrl;
      previewImg.alt = 'Your uploaded design';
      preview.appendChild(previewImg);
    };
    img.onerror = function () {
      showError('That file could not be read as an image. Please choose a different file.');
      URL.revokeObjectURL(objectUrl);
    };
    img.src = objectUrl;
  });

  root.customPersonalizationReset = function () {
    clearError();
    fileInput.value = '';
    clearPreview();
  };

  root.customPersonalizationPrefill = function (data) {
    if (data.imageUrl) {
      clearPreview();
      previewLabel.hidden = true;
      preview.removeAttribute('data-empty');
      var previewImg = document.createElement('img');
      previewImg.src = data.imageUrl;
      previewImg.alt = 'Your previous design';
      preview.appendChild(previewImg);
      root.dataset.prefillImageUrl = data.imageUrl;
    }
  };
});
